import React, { useState } from "react";
import { ReactTitle } from "react-meta-tags";
import { useTranslation } from "react-i18next";

import AddAccount from "./addAccount";
import AddClient from "./addClient";
import LoadProviders from "./loadProviders";
import Modal from "../../../utils/customModal";
import useApi from "../../../hooks/useApi";
import {
  errorContainer,
  loadingModal,
  sucessInfoModal,
} from "../../../utils/functions";

const ClientsProvider = ({ providerId, countryCode }) => {
  const [account, setAccount] = useState(null);
  const [modal, setModal] = useState({ show: false, content: null });
  const [loading, setLoading] = useState(false);
  const [step, setStep] = useState(1);

  const { postApiCAll } = useApi();
  const { t } = useTranslation();

  const changeStep = (newStep) => setStep(newStep);
  const updateAccount = (selectedAccounts) => setAccount(selectedAccounts);

  const addProviderCompany = async (data) => {
    let error = null;
    setLoading(true);
    try {
      await postApiCAll(`/providers/add-provider-company/${providerId}`, {
        accounts: [account.id],
        addCompanyProvider: data,
      });
    } catch (err) {
      error = err.response.data.notifications[0];
    }
    setLoading(false);
    error ? errorResponse(error) : successResponse();
  };

  const closeModal = () => setModal({ show: false, content: null });

  const errorResponse = ({ message, description }) => {
    setModal({
      show: true,
      content: errorContainer(message, description, {
        cancelBtn: { text: t("general.buttons.close"), action: closeModal },
      }),
    });
  };

  const successResponse = () => {
    setModal({
      show: true,
      content: sucessInfoModal(
        t("general.successMessage"),
        t("general.special_codition.success"),
        {
          formBtn: {
            text: t("general.buttons.continue"),
            action: () => {
              closeModal();
              setStep(1);
            },
          },
        }
      ),
    });
  };

  const renderComponent = () => {
    if (step === 1)
      return (
        <LoadProviders
          providerId={providerId}
          changeStep={() => changeStep(2)}
        />
      );

    if (step === 2)
      return (
        <AddAccount
          changeStep={changeStep}
          providerId={providerId}
          updateAccount={updateAccount}
        />
      );

    if (step === 3)
      return (
        <AddClient
          changeStep={changeStep}
          handleSubmit={addProviderCompany}
          countryCode={countryCode}
          providerId={providerId}
          currency={account.accountCurrency}
        />
      );
  };

  return (
    <>
      <ReactTitle title={`Gestión de Proveedores - Clientes`} />
      {renderComponent()}
      {loading && loadingModal()}
      <Modal show={modal.show}>{modal.content}</Modal>
    </>
  );
};

export default ClientsProvider;
